var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UIIcon',{class:'asb-flag-icon',attrs:{"icon":'flag-icon flag-icon--' + _vm.ISO.toLowerCase()}})}
var staticRenderFns = []

export { render, staticRenderFns }